import classNames from "classnames";
import React from "react";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";
import { useBootstrapPrefix } from "./ThemeProvider";

export interface TypographyProps extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {
	variant:
		| "title-1"
		| "title-2"
		| "title-3"
		| "subtitle-1"
		| "subtitle-2"
		| "h1"
		| "h2"
		| "h3"
		| "h4"
		| "body"
		| "caption";
	gutterBottom?: boolean;
}

export const Typography: BsPrefixRefForwardingComponent<"div", TypographyProps> = React.forwardRef<
	HTMLElement,
	TypographyProps
>(({ as: Component = "div", bsPrefix, className, variant, gutterBottom, ...props }, ref) => {
	bsPrefix = useBootstrapPrefix(bsPrefix, `ui3-${variant}`);

	return (
		<Component
			ref={ref}
			className={classNames(className, gutterBottom ? "ui3-gutter-bottom" : "ui3-no-gutter-bottom", bsPrefix)}
			{...props}
		/>
	);
});
